import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount } from "@nosto/preact"
import { useState, useRef } from "preact/hooks"

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            for={lableFor}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
        >
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )}
        </label>
    )
}

export default function Toolbar({ lableFor, onToggleSidebar, categoryHeader, isSearch }) {
    const { loading, query, response, pageType } = useAppState()
    const selectedFiltersCount = useSelectedFiltersCount()

    const docCount = response.products?.total ?? 0

    const totalSummary = categoryHeader ? '' : `${docCount} result${docCount > 1 ? 's' : ''} found for "${query.query}"`

    const miniSearchQuery = useRef()

    const searchInputField = document.querySelector('#header-search');

    function handleClick(){
        searchInputField.value = miniSearchQuery.current.value
        document.querySelector('#ns-autocomplete-submit-button').click()
      }

      function enterHandler(event){
        if (event.key === 'Enter') {
            console.log('Enter')
            handleClick()
        } else {
            searchInputField.value = miniSearchQuery.current.value
            searchInputField.click()
        }
      }

    return (
        <div
            class="ns-header-controls ns-flex-row ns-d-flex  ns-flex-wrap align-center ns-justify-content-between"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {isSearch &&
                <div class="field">
                    <input class="search__input field__input pb-4 text-16 border-b" value={query.query} onKeyDown={enterHandler} type="text" ref={miniSearchQuery} autofocus="" placeholder="Search" />
                    <button class="search__button w-16" onClick={handleClick}>
                        <svg class="icon icon-search icon--full-color" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.91406 10.1577L12.1478 13.3915" stroke="currentColor"></path>
                            <circle cx="5.87197" cy="6.16665" r="5.15908" stroke="currentColor"></circle>
                        </svg>
                    </button>
                </div>
            }
            {!loading && (
                <span
                    class={` ${isSearch ? 'ns-results-number' : 'ns-d-block'} ns-text-align-center ns-align-self-center ns-color-black`}
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )}
            <button class={` ${!isSearch ? 'ns-ml-auto' : ''} filter-drawer-trigger flex items-center`} onClick={onToggleSidebar}>
                <span>Filter / Sort</span>  
            </button>
        </div>
    )
}
